import { EMPTY_ARRAY } from 'constants';
import { AdminContext } from 'constants/contexts';
import { useHasAnyOfPermissions } from 'hooks/useHasPermission';
import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router';

function withGuard(Component, permissions, {
  redirect = false,
  fallback = null,
}) {
  return function (props) {
    const hasPermission = useHasAnyOfPermissions(permissions || EMPTY_ARRAY);
    const { isLoggedIn } = useContext(AdminContext);
    const navigate = useNavigate();
    const location = useLocation();
    if (hasPermission) {
      return <Component {...props} />;
    }
    if (redirect) {
      // This timeout is to ensure that routes are loaded before the redirect
      setTimeout(() => {
        navigate('/login', {
          replace: true,
          // Signed-in users lacking permission would be sent straight back here after login.
          state: isLoggedIn ? null : { from: location },
        });
      }, 1);
    }
    return fallback;
  };
}

export default withGuard;
